import { secureGet, securePost, secureDelete } from '../../Config/ApiConfig';

const BASE_URL_EXPORTS = '/data-exports';
const BASE_URL_IMPORTS = '/data-imports';

const buildListQueryParams = (params = {}) => {
    const { signal, filters, ...queryParams } = params;
    const cleanedParams = { ...queryParams };

    if (filters && Object.keys(filters).length > 0) {
        cleanedParams.filters = JSON.stringify(filters);
    }

    return { signal, queryParams: cleanedParams };
};

export const getDataExports = async (params) => {
    try {
        const { signal, queryParams } = buildListQueryParams(params);
        const { data } = await secureGet(BASE_URL_EXPORTS, {
            params: queryParams,
            ...(signal ? { signal } : {}),
        });
        return {
            data: data.data,
            metadata: data.metadata
        };
    } catch (error) {
        throw error;
    }
};

export const createDataExport = async (payload) => {
    try {
        const { data } = await securePost(BASE_URL_EXPORTS, payload);
        return data;
    } catch (error) {
        throw error;
    }
};

export const deleteDataExport = async (id) => {
    try {
        const { data } = await secureDelete(`${BASE_URL_EXPORTS}/${id}`);
        return data;
    } catch (error) {
        throw error;
    }
};

export const getDataImports = async (params) => {
    try {
        const { signal, queryParams } = buildListQueryParams(params);
        const { data } = await secureGet(BASE_URL_IMPORTS, {
            params: queryParams,
            ...(signal ? { signal } : {}),
        });
        return {
            data: data.data,
            metadata: data.metadata
        };
    } catch (error) {
        throw error;
    }
};

export const createDataImport = async (payload) => {
    try {
        const { data } = await securePost(BASE_URL_IMPORTS, payload);
        return data;
    } catch (error) {
        throw error;
    }
};

export const deleteDataImport = async (id) => {
    try {
        const { data } = await secureDelete(`${BASE_URL_IMPORTS}/${id}`);
        return data;
    } catch (error) {
        throw error;
    }
};

export const uploadFile = async (file) => {
    const formData = new FormData();
    if (file && file.name) {
        formData.append('file', file, file.name);
    } else {
        formData.append('file', file);
    }

    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    };

    const { data } = await securePost('/file-uploads', formData, config);
    return data;
};

